export default __webpack_public_path__ + "static/media/Aura-Egg__35.2b095eb8.png";